export default __webpack_public_path__ + "static/media/rambeez.a6979341.png";